import { SvgIcon } from 'ui/icons';

export const Segment = () => (
  <SvgIcon height="128" width="128" viewBox="0 0 128 128">
    <g clipPath="url(#clip0)">
      <path
        d="M115.84 71.808C115.84 64.1676 114.129 56.6242 110.834 49.7309C107.539 42.8377 102.742 36.7693 96.797 31.9706C90.8515 27.172 83.9074 23.7649 76.4739 21.999C69.0403 20.2332 61.3058 20.1534 53.8374 21.7655C46.3691 23.3776 39.3561 26.6407 33.3129 31.3156C27.2696 35.9905 22.3492 41.9586 18.9125 48.7824C15.4758 55.6063 13.6098 63.1127 13.4514 70.7515C13.2931 78.3902 14.8463 85.9676 17.9972 92.928H111.284C114.293 86.2941 115.847 79.0926 115.84 71.808Z"
        fill="#F5F4F4"
      />
      <path
        d="M14.0801 92.9282H113.92"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32031 92.9282H11.5203"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.48 92.9282H119.68"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.91 104.96C95.91 106.24 81.83 107.392 64.3324 107.392C46.8348 107.392 32.7676 106.304 32.7676 104.96C32.7676 103.616 46.8476 102.528 64.3324 102.528C81.8172 102.528 95.91 103.68 95.91 104.96Z"
        fill="#F5F4F4"
      />
      <circle cx="39" cy="89" r="15.5" fill="white" stroke="#6A266D" />
      <path d="M35 98.5V95.5H43V98.5H35Z" fill="#B56DC6" stroke="#6A266D" />
      <path fillRule="evenodd" clipRule="evenodd" d="M44.5 89V86.5Z" fill="white" />
      <path d="M44.5 89V86.5V84.5H33.5V89L36 91H42L44.5 89Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.5 89V86.5Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.5 89V86.5V84.5H33.5V89L36 91H42L44.5 89Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M39 100.5V96" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M38 87.0002C37.7842 86.6621 37.4 86.47 37 86.5002C36.6 86.47 36.2158 86.6621 36 87.0002"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 87.0002C41.7842 86.6621 41.4 86.47 41 86.5002C40.6 86.47 40.2158 86.6621 40 87.0002"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39 96C48 96 44.5 89 44.5 89C43.7507 89.5139 42.897 89.8554 42 90C41 90 41 88.5 39 88.5C37 88.5 37 90 36 90C35.103 89.8554 34.2493 89.5139 33.5 89C33.5 89 30 96 39 96Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5 92C37.8727 92.3332 38.3582 92.512 38.858 92.5H39.142C39.6418 92.5122 40.1274 92.3334 40.5 92"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45 82.5H33C32.4477 82.5 32 82.9477 32 83.5C32 84.0523 32.4477 84.5 33 84.5H45C45.5523 84.5 46 84.0523 46 83.5C46 82.9477 45.5523 82.5 45 82.5Z"
        fill="#E6FBFF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.917 82.5001C44.4314 79.6107 41.9299 77.4946 39 77.4946C36.0701 77.4946 33.5687 79.6107 33.083 82.5001"
        fill="#B56DC6"
      />
      <path
        d="M44.917 82.5001C44.4314 79.6107 41.9299 77.4946 39 77.4946C36.0701 77.4946 33.5687 79.6107 33.083 82.5001"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M39 82.5V84.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M35.5 82.5V84.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M42.5 82.5V84.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M39 97.4999L42.842 98.7809C42.9946 98.8317 43.1623 98.806 43.2927 98.7119C43.423 98.6178 43.5002 98.4667 43.5 98.3059V95.2769"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5 95.2769V98.3059C34.4998 98.4667 34.577 98.6178 34.7073 98.7119C34.8377 98.806 35.0054 98.8317 35.158 98.7809L39 97.4999"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.5 100.5C50.4991 98.8318 49.4628 97.3391 47.9 96.7552L43.21 95.1792"
        fill="#6A266D"
      />
      <path
        d="M50.5 100.5C50.4991 98.8318 49.4628 97.3391 47.9 96.7552L43.21 95.1792V98.709L39 97.5V100.5H50.5Z"
        fill="#6A266D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.5 100.5C50.4991 98.8318 49.4628 97.3391 47.9 96.7552L43.21 95.1792"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.5 100.5C50.4991 98.8318 49.4628 97.3391 47.9 96.7552L43.21 95.1792V98.709L39 97.5V100.5H50.5Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.79 95.1792L30.1 96.7552C28.5371 97.3391 27.5008 98.8318 27.5 100.5"
        fill="#6A266D"
      />
      <path
        d="M34.79 95.1792L30.1 96.7552C28.5371 97.3391 27.5008 98.8318 27.5 100.5L39 100.5V97.5L34.79 98.6231V95.1792Z"
        fill="#6A266D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.79 95.1792L30.1 96.7552C28.5371 97.3391 27.5008 98.8318 27.5 100.5"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.79 95.1792L30.1 96.7552C28.5371 97.3391 27.5008 98.8318 27.5 100.5L39 100.5V97.5L34.79 98.6231V95.1792Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M39 97V101" stroke="#B56DC6" />
      <circle cx="85" cy="75" r="23.5" fill="white" stroke="#6A266D" />
      <path
        d="M102.25 92.25H67.7499C67.6663 89.8441 68.1125 88.1238 69.5224 86.754C70.9843 85.3337 73.4823 84.2902 77.4999 83.25C83.1804 85.8357 86.4821 85.7107 92.4999 83.25C100.235 85.2169 102.582 87.0993 102.25 92.25Z"
        fill="#FDF5FF"
        stroke="#6A266D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.75 83.7V69.3C100.75 66.1189 98.064 63.54 94.7503 63.54C94.7503 63.54 79.7503 63.7502 74.5003 63.7502"
        fill="#B56DC6"
      />
      <path
        d="M100.75 83.7V69.3C100.75 66.1189 98.064 63.54 94.7503 63.54C94.7503 63.54 79.7503 63.7502 74.5003 63.7502C69.2503 63.7502 69.2507 67.5002 69.2503 69.3C69.2499 71.0998 69.2503 83.7 69.2503 83.7H100.75Z"
        fill="#B56DC6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.75 83.7V69.3C100.75 66.1189 98.064 63.54 94.7503 63.54C94.7503 63.54 79.7503 63.7502 74.5003 63.7502"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M100.75 83.7V69.3C100.75 66.1189 98.064 63.54 94.7503 63.54C94.7503 63.54 79.7503 63.7502 74.5003 63.7502C69.2503 63.7502 69.2507 67.5002 69.2503 69.3C69.2499 71.0998 69.2503 83.7 69.2503 83.7H100.75Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.25 73.6202C72.25 80.7785 77.5435 85.1402 85 85.1402C92.4565 85.1402 97.75 80.7785 97.75 73.6202V72.1802C97.75 65.022 92.4565 59.2202 85 59.2202C77.5435 59.2202 72.25 65.022 72.25 72.1802V73.6202Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.75 72.9C94.75 78.0696 90.385 79.38 85 79.38C79.615 79.38 75.25 78.0696 75.25 72.9C75.25 67.7307 79.6152 63.54 85 63.54C90.3848 63.54 94.75 67.7307 94.75 72.9Z"
        fill="#E6FBFF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M79.2695 71.1897C79.8536 69.3975 81.3078 67.9891 83.1695 67.4126"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.25 92.34V90.9C102.249 88.4975 100.694 86.3481 98.35 85.5072L92.1025 83.4912"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.8915 83.4941L71.65 85.5073C69.3057 86.3481 67.7513 88.4976 67.75 90.9001V92.3401"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79 92.3405C78.5858 92.3405 78.25 92.0182 78.25 91.6205V89.4605C78.25 88.6652 78.9216 88.0205 79.75 88.0205H90.25C91.0784 88.0205 91.75 88.6652 91.75 89.4605V91.6205C91.75 92.0182 91.4142 92.3405 91 92.3405H79Z"
        fill="#B56DC6"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.75 88.0205V92.3405"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M94.75 90.9004H97.75"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.25 92.3403H75.25"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.75 89.4604H75.25"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="48" cy="46" r="15.5" fill="white" stroke="#6A266D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.9996 51.4998C49.3866 51.4998 52.4896 49.7788 52.9316 47.1348C52.9863 46.8064 53.2007 46.5268 53.5036 46.3888C54.5816 45.8988 54.8516 43.9368 53.9806 43.4998C54.4806 40.5138 54.4806 35.4998 47.9996 35.4998C46.746 35.4513 45.5 35.7152 44.3736 36.2678C41.5496 37.7878 41.6416 41.2298 42.0186 43.4998C41.1476 43.9368 41.4186 45.8998 42.4956 46.3888C42.7986 46.5268 43.013 46.8064 43.0676 47.1348C43.5096 49.7788 46.6126 51.4998 47.9996 51.4998Z"
        fill="white"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.5 48C46.8727 48.3332 47.3582 48.512 47.858 48.5H48.142C48.6418 48.5122 49.1274 48.3334 49.5 48"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47 44.0002C46.7842 43.6621 46.4 43.47 46 43.5002C45.6 43.47 45.2158 43.6621 45 44.0002"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51 44.0002C50.7842 43.6621 50.4 43.47 50 43.5002C49.6 43.47 49.2158 43.6621 49 44.0002"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.8281 41.4849C43.1591 41.4489 45.8711 41.8759 48.0001 39.3149C50.1171 41.8619 52.8431 41.4639 54.1721 41.4929"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.2627 36.33C43.6767 34.9465 42.1578 34.2099 40.7086 34.6063C39.2595 35.0027 38.327 36.41 38.5269 37.8991C38.7268 39.3881 39.9973 40.4997 41.4997 40.5C41.6217 40.4999 41.7436 40.4922 41.8647 40.477"
        fill="#FDF5FF"
      />
      <path
        d="M44.2627 36.33C43.6767 34.9465 42.1578 34.2099 40.7086 34.6063C39.2595 35.0027 38.327 36.41 38.5269 37.8991C38.7268 39.3881 39.9973 40.4997 41.4997 40.5C41.6217 40.4999 41.7436 40.4922 41.8647 40.477"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.7373 36.33C52.3232 34.9465 53.8422 34.2099 55.2913 34.6063C56.7405 35.0027 57.6729 36.41 57.4731 37.8991C57.2732 39.3881 56.0027 40.4997 54.5003 40.5C54.3783 40.4999 54.2564 40.4922 54.1353 40.477"
        fill="#FDF5FF"
      />
      <path
        d="M51.7373 36.33C52.3232 34.9465 53.8422 34.2099 55.2913 34.6063C56.7405 35.0027 57.6729 36.41 57.4731 37.8991C57.2732 39.3881 56.0027 40.4997 54.5003 40.5C54.3783 40.4999 54.2564 40.4922 54.1353 40.477"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.5 57.5001C59.4992 55.8317 58.4629 54.339 56.9 53.7551L51.87 52.0661C51.6579 51.9949 51.4242 52.0733 51.298 52.2581C50.5523 53.3467 49.3176 53.9975 47.998 53.9975C46.6784 53.9975 45.4437 53.3467 44.698 52.2581C44.5715 52.0737 44.3379 51.9957 44.126 52.0671L39.1 53.7551C37.5371 54.339 36.5008 55.8317 36.5 57.5001"
        fill="#B56DC6"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.0001 35.5C41.5002 35.5 42.0001 41.5 42.0001 41.5C42.0001 41.5 44.3159 41.4919 45.5 41C46.6719 40.5131 47.1661 39.5 48 39.5C48.8339 39.5 49.3725 40.5316 50.5 41C51.6841 41.4919 54 41.5 54 41.5C54 41.5 54.5 35.5 48.0001 35.5Z"
        fill="#FDF5FF"
        stroke="#6A266D"
      />
      <path
        d="M48.409 56.5601C50.7376 56.5601 52.8517 55.2006 53.818 53.082L51.9092 53C51.9092 53 49.9092 54.5 48.4092 54.5C46.9092 54.5 44.9092 53 44.9092 53L43 53.082C43.9663 55.2006 46.0804 56.5601 48.409 56.5601Z"
        fill="#E6FBFF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="128" height="128" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
